import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Label from '../Texts/Label/Label';
import Icon from '../Icon/Icon';
import Span from '../Texts/Span/Span';
import * as S from './Select.styles';

const Select = ({
  id,
  options,
  placeholder = 'Seleccione...',
  name,
  label,
  onChange,
  onBlur,
  error,
  message,
  disabled,
  reset,
  value,
}) => {
  const defaultValue = value ? value : placeholder;
  const [selectedOption, setSelectedOption] = useState(defaultValue);

  useEffect(() => {
    setSelectedOption(defaultValue);
  }, [value]);

  useEffect(() => {
    if (selectedOption !== defaultValue && reset) {
      setSelectedOption(defaultValue);
    }
  }, [reset]);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    onChange && onChange(event);
  };

  return (
    <S.Select>
      {label && (
        <S.LabelWrapper>
          <Label id={id} type='4'>
            {label}
          </Label>
        </S.LabelWrapper>
      )}
      <S.SelectTag
        value={selectedOption}
        name={name}
        onChange={handleChange}
        onBlur={onBlur}
        error={error}
        disabled={disabled}
      >
        <option disabled hidden>
          {placeholder}
        </option>
        {options.length > 0 &&
          options.map(({ value, label, disabled }) => (
            <option key={value} value={value} disabled={!!disabled}>
              {label}
            </option>
          ))}
      </S.SelectTag>
      {message && (
        <S.HelpText status={error}>
          {error && (
            <Icon
              name='error_circle_outline'
              variant='danger'
              width='16'
              height='16'
            />
          )}
          <Span id={id} type='4' variant={error ? 'danger' : 'neutral'}>
            {message}
          </Span>
        </S.HelpText>
      )}
    </S.Select>
  );
};

Select.defaultProps = {
  placeholder: 'Seleccione...',
};

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  message: PropTypes.string,
  disabled: PropTypes.bool,
  reset: PropTypes.bool,
  value: PropTypes.string,
};

export default Select;
